/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type ProjectsRoot_viewer = {
    readonly designFirm?: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly profileStatus: DesignProfileStatus | null;
        readonly publicProfile: {
            readonly urlLabel: string | null;
            readonly liveDesignProjects?: ReadonlyArray<{
                readonly serviceId: string | null;
                readonly status: string | null;
                readonly " $fragmentRefs": FragmentRefs<"DisplayDesignProjectTile_designProject">;
            } | null> | null;
            readonly editModeDesignProjects?: ReadonlyArray<{
                readonly serviceId: string | null;
                readonly status: string | null;
                readonly " $fragmentRefs": FragmentRefs<"EditDesignProjectTile_designProject">;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": "ProjectsRoot_viewer";
};
export type ProjectsRoot_viewer$data = ProjectsRoot_viewer;
export type ProjectsRoot_viewer$key = {
    readonly " $data"?: ProjectsRoot_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ProjectsRoot_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ProjectsRoot_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "firmUrlLabel",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "shouldRenderProjects",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isEditMode",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "shouldRenderProjects",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "designFirm",
          "name": "tradeFirms",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "pageSize",
              "value": 1
            },
            {
              "kind": "Variable",
              "name": "urlLabel",
              "variableName": "firmUrlLabel"
            }
          ],
          "concreteType": "TradeFirmType",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "profileStatus",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "publicProfile",
              "storageKey": null,
              "args": null,
              "concreteType": "TradeFirmPublicProfileType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "urlLabel",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "Condition",
                  "passingValue": false,
                  "condition": "isEditMode",
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": "liveDesignProjects",
                      "name": "designProjectsCover",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "DesignProjectCover",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        {
                          "kind": "FragmentSpread",
                          "name": "DisplayDesignProjectTile_designProject",
                          "args": null
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "Condition",
                  "passingValue": true,
                  "condition": "isEditMode",
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": "editModeDesignProjects",
                      "name": "designProjects",
                      "storageKey": "designProjects(status:[\"ACTIVE\",\"PENDING\"],visibility:[\"Y\",\"N\"])",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "status",
                          "value": [
                            "ACTIVE",
                            "PENDING"
                          ]
                        },
                        {
                          "kind": "Literal",
                          "name": "visibility",
                          "value": [
                            "Y",
                            "N"
                          ]
                        }
                      ],
                      "concreteType": "designProject",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        {
                          "kind": "FragmentSpread",
                          "name": "EditDesignProjectTile_designProject",
                          "args": null
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '3daba2df289b46393430143114bfa4a0';
export default node;
